module.exports = __webpack_public_path__ + "public/images/generated-managing-emotions.79418501289f7cd63a1f4ec99b34d7fd.jpg";